import {
  Box,
  Dialog,
  DialogContent,
  Link,
  Typography,
  Button,
} from "@mui/material";
import { useRouter } from "next/router";
import { useSnackbar } from "notistack";
import { useResendConfirmationEmailMutation } from "queries/useResendConfirmationEmail";
import * as React from "react";

import { ROUTES } from "../../../constants/routes";

import SendEmail from "icons/SendEmail";

interface ConfirmEmailDialogProps {
  open: boolean;
  email: string | undefined;
}

export const ConfirmEmailDialog: React.FC<ConfirmEmailDialogProps> = ({
  open,
  email,
}) => {
  const router = useRouter();
  const [resendEmailConfirmation] = useResendConfirmationEmailMutation();
  const { enqueueSnackbar } = useSnackbar();

  const tryResendConfirmationEmail = async () => {
    if (email)
      try {
        await resendEmailConfirmation({
          variables: { email },
        });
        enqueueSnackbar("Resent!", { variant: "success" });
      } catch (err: unknown) {
        enqueueSnackbar("An Error Occurred", { variant: "error" });
      }
  };

  return (
    <Dialog
      open={open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      style={{ width: "400px", margin: "0 auto" }}
    >
      <DialogContent>
        <Typography
          align="center"
          color="textPrimary"
          style={{ fontSize: "32px", fontWeight: 700, marginBottom: "20px" }}
        >
          Please verify your email
        </Typography>
        <Box
          sx={{
            display: "flex",
            alignContent: "center",
            justifyContent: "center",
          }}
        >
          <SendEmail width={300} height={200} />
        </Box>
        <Typography
          align="center"
          color="textPrimary"
          style={{
            fontSize: "18px",
            fontWeight: 400,
            lineHeight: "27px",
            marginTop: "20px",
          }}
        >
          Please click the verification link in the email, and then sign in to
          continue.
        </Typography>

        <Box sx={{ mt: 2 }}>
          <Button
            color="secondary"
            style={{ width: "60%", marginLeft: "20%" }}
            size="large"
            type="submit"
            variant="contained"
            onClick={() => {
              router.push({
                pathname: `${ROUTES.AUTH_LOGIN}`,
              });
            }}
          >
            Sign in
          </Button>
        </Box>
        <Typography
          align="center"
          color="textPrimary"
          style={{
            fontSize: "18px",
            fontWeight: 400,
            lineHeight: "27px",
            marginTop: "20px",
          }}
        >
          {"Didn’t receive an email? "}
          <Link
            color="primary"
            component="a"
            style={{ textDecoration: "none", cursor: "pointer" }}
            onClick={() => {
              tryResendConfirmationEmail();
            }}
          >
            Resend
          </Link>
        </Typography>
      </DialogContent>
    </Dialog>
  );
};
